import { WeldlineSetupPage } from "../../pages/weldline-setup";

export const routeWeldlineSetup = "/weldline-setup";

export const weldlineSetupRoutes = [
	{
		path: routeWeldlineSetup,
		element: <WeldlineSetupPage />,
	},
	{
		path: `${routeWeldlineSetup}/:productId`,
		element: <WeldlineSetupPage />,
	},
];
